export default class CustomerConfig {
  #returnUrl;
  #hideNavbar;
  #hideLogo;
  #disableScrolling;

  get returnUrl() {
    return this.#returnUrl;
  }

  /**
   * Set the returnUrl that should be followed when redirecting after login or logout
   * @param {string} localUrl - A string url to a local path.
   */
  set returnUrl(localUrl) {
    this.#returnUrl = localUrl;
  }

  /**
   * True if the main navbar should be hidden. Always false if page is not framed.
   */
  get hideNavbar() {
    return this.#hideNavbar && window !== window.parent;
  }

  /**
   * True if the customer logo should be hidden. Always false if page is not framed.
   */
  get hideLogo() {
    return this.#hideLogo && window !== window.parent;
  }

  /**
   * True if scrolling should be disabled. Always false if page is not framed.
   */
  get disableScrolling() {
    return this.#disableScrolling && window !== window.parent;
  }

  constructor(config) {
    if (config) {
      this.#returnUrl = config.returnUrl;
      this.#hideNavbar = config.hideNavbar;
      this.#hideLogo = config.hideLogo;
      this.#disableScrolling = config.disableScrolling;
    } else {
      this.#returnUrl = "";
      this.#hideNavbar = false;
      this.#hideLogo = false;
      this.#disableScrolling = false;
    }
  }

  parseQueryString(url) {
    const i = url.indexOf("?");
    if (i > 0) {
      const query = url.substring(i).toLowerCase();
      const params = new URLSearchParams(query);

      this.#returnUrl = params.get("returnurl") ?? "";
      this.#hideNavbar = params.get("hidenav") ?? false;
      this.#hideLogo = params.get("hidelogo") ?? false;
      this.#disableScrolling = params.get("disablescrolling") ?? false;
    }
  }

  mergeConfig(other) {
    if (other.returnUrl) {
      this.#returnUrl = other.returnUrl;
    }
    if (other.hideNavbar) {
      this.#hideNavbar = other.hideNavbar;
    }
    if (other.hideLogo) {
      this.#hideLogo = other.hideLogo;
    }
    if (other.disableScrolling) {
      this.#disableScrolling = other.disableScrolling;
    }
  }

  /**
   * Creates a query string from the configuration without a preceding ?
   * Returns an empty string if there is no config.
   * @returns the query string
   */
  toQueryString() {
    const queries = [];
    if (this.#returnUrl) {
      queries.push(`ReturnUrl=${encodeURIComponent(this.#returnUrl)}`);
    }
    if (this.#hideNavbar) {
      queries.push("HideNav=true");
    }
    if (this.#hideLogo) {
      queries.push("HideLogo=true");
    }
    if (this.#disableScrolling) {
      queries.push("DisableScrolling=true");
    }

    return queries.join("&");
  }
}
